var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPropLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6387_126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.519 505.32C246.301 509.493 250.985 512 256 512C261.015 512 265.699 509.494 268.481 505.32C303.98 452.073 356.267 386.312 392.703 319.431C421.837 265.955 436 220.346 436 180C436 80.748 355.252 0 256 0C156.748 0 76 80.748 76 180C76 220.346 90.163 265.955 119.297 319.431C155.706 386.261 208.093 452.183 243.519 505.32ZM256 30C338.71 30 406 97.29 406 180C406 215.204 393.033 256.118 366.359 305.079C334.952 362.728 290.134 421.207 256 470.369C221.871 421.214 177.05 362.731 145.641 305.079C118.967 256.118 106 215.204 106 180C106 97.29 173.29 30 256 30Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 270C305.626 270 346 229.626 346 180C346 130.374 305.626 90 256 90C206.374 90 166 130.374 166 180C166 229.626 206.374 270 256 270ZM256 120C289.084 120 316 146.916 316 180C316 213.084 289.084 240 256 240C222.916 240 196 213.084 196 180C196 146.916 222.916 120 256 120Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6387_126"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropLocation);
export default __webpack_public_path__ + "static/media/prop-location.3f9980778276ea131478a1bc5969f009.svg";
export { ForwardRef as ReactComponent };